/**
 * Only these internal SHAPES may be carried through authentication.
 *
 * An allowlist of shapes, never a pass-through of arbitrary paths: a crafted `returnTo` would
 * otherwise be an open redirect. Keep it narrow — each entry is a specific destination someone
 * can legitimately be sent to from outside the app.
 */
const ALLOWED = [
  // Claim links, from the claim email.
  /^\/claim\/[1-9][0-9]*$/,
  // A single order, from the booking notification email (order-creation design §G).
  /^\/dashboard\?tab=orders&orderId=[1-9][0-9]*$/,
];

export function claimReturnPath(search) {
  const value = new URLSearchParams(search || '').get('returnTo');
  if (!value) return null;
  return ALLOWED.some((re) => re.test(value)) ? value : null;
}
